import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "./App.css";

// Layout Components
import NavBar from "./Components/NavBar/NavBar";
import Footer from "./Components/Footer/Footer";
import WhatsappButton from "./Components/WhatsappButton/WhatsappButton";

// Pages
import Home from "./Components/Home/Home";
import About from "./Components/About/About";
import Contact from "./Components/Contact/Contact";
import TermsAndConditions from "./Components/terms&conditions/TermsAndConditions";
import Destinations from "./Components/Destinations/Destinations";
import SelfDrive from "./Components/SelfDrive/SelfDrive";
import Gallery from "./Components/Gallery/Gallery";
import WhyUs from "./Components/WhyUs/WhyUs";
import CustomerReview from "./Components/CustomerReview/CustomerReview";
import MostVisit from "./Components/MostVisit/MostVisit";

// Scroll Fix
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  return null;
};

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />

        {/* Navbar */}
        <NavBar />

        {/* Routes */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/self-drive-cars" element={<SelfDrive />} />
          <Route path="/temple-tours" element={<Destinations />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/why-us" element={<WhyUs />} />
          <Route path="/reviews" element={<CustomerReview />} />
          <Route path="/most-visited-places" element={<MostVisit />} />

          {/* Redirect old URLs */}
          <Route path="/selfdrive" element={<SelfDrive />} />
          <Route path="/tours" element={<Destinations />} />
          <Route path="/terms&conditions" element={<TermsAndConditions />} />

          {/* 404 fallback */}
          <Route path="*" element={<Home />} />
        </Routes>

        {/* Floating Button */}
        <WhatsappButton />

        {/* Footer */}
        <Footer />
      </Router>
    </HelmetProvider>
  );
}

export default App;